import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Gift, Save } from "lucide-react";

export default function SettingsWidget() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ sample_box_fee: "", sample_box_fee_note: "", sample_box_lead_time: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/public").then((r) => { setSettings(r.data); setForm(r.data); });
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings", form);
      setSettings(data);
      toast.success("Settings saved");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return null;

  return (
    <form onSubmit={save} data-testid="settings-widget" className="bg-white border border-brand-line rounded-3xl p-6 shadow-soft">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-brand-pinkLight text-brand-red grid place-items-center"><Gift className="w-5 h-5" /></div>
        <div>
          <div className="eyebrow">Sample Box</div>
          <h3 className="font-display text-lg text-brand-ink leading-none mt-1">Fee & program settings</h3>
        </div>
      </div>

      <div className="mt-5 grid sm:grid-cols-3 gap-4">
        <Field label="Sample box fee" value={form.sample_box_fee || ""} onChange={set("sample_box_fee")} testId="setting-fee" placeholder="$95" />
        <Field label="Lead time" value={form.sample_box_lead_time || ""} onChange={set("sample_box_lead_time")} testId="setting-lead" placeholder="3–5 business days" />
        <Field label="Fee note" value={form.sample_box_fee_note || ""} onChange={set("sample_box_fee_note")} testId="setting-note" placeholder="Refundable — credited toward…" />
      </div>

      <button type="submit" disabled={saving} data-testid="save-settings" className="mt-5 inline-flex items-center gap-2 h-10 px-5 rounded-full bg-brand-ink text-white text-xs font-ui font-semibold hover:bg-brand-red disabled:opacity-50 transition">
        <Save className="w-4 h-4" /> {saving ? "Saving…" : "Save settings"}
      </button>
    </form>
  );
}

function Field({ label, value, onChange, testId, placeholder }) {
  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-wide text-brand-ink">{label}</label>
      <input
        type="text" value={value} onChange={onChange} placeholder={placeholder} data-testid={testId}
        className="mt-1.5 w-full h-11 rounded-xl bg-white border border-brand-line px-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-red placeholder:text-brand-stoneLight"
      />
    </div>
  );
}
